import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RecordConcernVisitResponse extends BackendResponse {}

export interface RecordConcernVisitParameters extends NextApiParams {
  concernId: number;
}

export const recordConcernVisit = withNextApi<
  RecordConcernVisitResponse,
  RecordConcernVisitParameters
>("/metadata/RecordConcernVisit", { method: "POST" });
